"use strict";

var Sorttable = function() {

  var dynamicTable = function() {

    var  columns_list = document.getElementById('columns-list');
    var  items      = document.querySelectorAll('.items');
    var  order_value_input = $(".order_value");
    var  order_value_hidden_input = $(".order_value_hidden");
    var  width_value_input = $(".width_value");
    var  width_as_text = $(".width_as_text");
    var  width_value_hidden = $(".width_value_hidden");
    var  visibility_value_input = $(".visibility-control-input");

    for (let i = 1; i <= items.length; i++) {
      order_value_input[i-1].textContent = i+".";
      order_value_hidden_input[i-1].value = i;
      width_value_hidden[i-1].value = width_value_input[i-1].value;
    }

    width_value_input.change(function(){
      for (let i = 1; i <= items.length; i++) {
        width_as_text[i-1].textContent = width_value_input[i-1].value+" px";
        width_value_hidden[i-1].value = width_value_input[i-1].value;
        if(width_value_input[i-1].value == "0")
        {
          visibility_value_input[i-1].checked = false;
        }
      }
    })


    const reorderInput = () => {
      var  order_value_input = $(".order_value");
      var  order_value_hidden_input = $(".order_value_hidden");

      for (let i = 1; i <= items.length; i++) {
        order_value_input[i-1].textContent = i+".";
        order_value_hidden_input[i-1].value = i;
      }
    }

    Sortable.create(columns_list, {
      animation: 150,
      handle: '.fa-grip-vertical', 
      onUpdate: () => {
        reorderInput();
      },
      onStart: () => {
        reorderInput();
      }
    });
  }

  return {
    init: function(){
      dynamicTable();
    }
  };
}();
// Webpack support
if (typeof module !== 'undefined') {
	module.exports = Sorttable;
}